/* Makes every footer on the site carry the same link columns, and the same
   company line. v11.

   v11 (13 Oct 2026, Glen) puts Rockkt AI (/pages/ai-b2b-gifting) first in the
   Features column, eleven links, matching the header menu
   (rockkt-nav-features-v5.js). The link count test in sync() rebuilds any
   ten-link column left from v10.

   v10 (9 Oct 2026, Glen) rebuilds the link columns the same way on every
   footer, so they finally agree everywhere:
     Features      the ten from the header menu (rockkt-nav-features-v4.js),
                   ROI added, same order
     How it works  Find the address, Write the letter, Design the envelope,
                   Land the page, Mission Control
     Rockkt        Pricing, Studio or Managed, Rockkt Managed, Compare, FAQ,
                   Contact, Join Rockkt
   "The Boring Stuff" leaves the columns and becomes "Terms and privacy" next
   to the copyright line (bottomLinks()). Any footer without the v10 columns
   has its old link columns removed and these three put in their place; the
   brand block is left alone. Earlier notes follow.

   v1 made the hand-built templates carry the two columns the shared page-foot
   snippet already had: "What it does" and "Rockkt". It skipped any footer that
   already had them.

   v2 added a "Features" column with the six pages that used to be homepage
   sections, everywhere, including the footers the snippet renders, and restyled
   the grid to four tracks.

   v3 is v2 with two more features in that column: Rockkt One and Playbooks,
   eight in total.

   v4 adds Integrations, nine in total, matching the header menu
   (rockkt-nav-features-v3.js). The band at the foot of the homepage
   (rockkt-router-v7.js) also carries nine but NOT the same nine: it has ROI
   where these two have Integrations, because the band stands in for sections
   that were moved off the homepage and Integrations never was one. The header
   menu's file explains the split in full.

   v5 drops "Delivered with care, from the UK." from the bottom bar.

   v6 drops "Registered in England & Wales." from the copyright line, leaving
   "© 2026 Rockkt." on its own. See name() for the one thing to check before
   anyone decides that was a good idea.

   v7 adds "Studio or Managed" (/pages/studio-or-managed) straight after
   Pricing, in whichever column Pricing sits in. See studioLink() for why that
   is found by the Pricing link rather than by column name.

   v8 (9 Oct 2026) replaces the badge row under the logo with two plain facts,
   "Royal Mail tracked" and "No minimum term". The old four (>99% via Royal
   Mail, FSC-certified, GDPR compliant, Carbon-conscious) had no source. Both
   footer snippets were fixed at source; badges() is for the hand-built
   templates that carry their own copy of the footer. See badges().

   v9 (9 Oct 2026) adds "Rockkt Managed" (/pages/sales-gifting) straight after
   "Studio or Managed", in every footer, and points every footer "Join Rockkt"
   link at /pages/join instead of /pages/request-an-invite. One link added, so
   the footer stays short. See managedLink() and joinLink().

   THE COUNT CHANGE IS SAFE TO SHIP. sync() below replaces any Features column
   whose link count does not match this list, so a footer left over from v3 is
   rebuilt with nine rather than kept at eight. That test was added in v3 for
   exactly this, and it is the reason a list can grow here without a cache
   problem.

   Playbooks points at /pages/send-playbooks, not /pages/playbooks: that handle
   belongs to the guides hub, which is content rather than product. The guides
   hub is reachable from Mission Control and the other content pages; it is
   deliberately not in this column, which is features only. */
(function () {
  var FEATURE_PAGES = [
    ['/pages/ai-b2b-gifting', 'Rockkt AI'],
    ['/pages/rockkt-one',     'Rockkt One'],
    ['/pages/send-playbooks', 'Playbooks'],
    ['/pages/gift-lab',       'Gift Lab'],
    ['/pages/design-studio',  'Design Studio'],
    ['/pages/flight-deck',    'Flight Deck'],
    ['/pages/tracking',       'Tracking'],
    ['/pages/roi',            'ROI'],
    ['/pages/navigator',      'Navigator'],
    ['/pages/compliance',     'Compliance'],
    ['/pages/integrations',   'Integrations']
  ];
  var WHAT_IT_DOES = [
    ['/pages/find-the-address', 'Find the address'],
    ['/pages/write-the-letter', 'Write the letter'],
    ['/pages/design-the-envelope', 'Design the envelope'],
    ['/pages/landing-pages', 'Land the page'],
    ['https://rockkt.com/blogs/how-rockkt-helps', 'Mission Control']
  ];
  var ROCKKT = [
    ['/pages/pricing', 'Pricing'],
    ['/pages/studio-or-managed', 'Studio or Managed'],
    ['/pages/sales-gifting', 'Rockkt Managed'],
    ['/pages/compare', 'Compare'],
    ['/pages/faq', 'FAQ'],
    ['/pages/contact', 'Contact'],
    ['/pages/join', 'Join Rockkt']
  ];

  function column(heading, links, cls) {
    var col = document.createElement('div');
    col.className = 'foot-col foot-links ' + cls;
    var h = document.createElement('h4');
    h.textContent = heading;
    col.appendChild(h);
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.href = l[0];
      a.textContent = l[1];
      col.appendChild(a);
    });
    return col;
  }

  function layout(grid) {
    var cols = grid.querySelectorAll('.foot-col').length;
    var w = window.innerWidth;
    if (w <= 620)      grid.style.gridTemplateColumns = '1fr';
    else if (w <= 960) grid.style.gridTemplateColumns = '1fr 1fr';
    else               grid.style.gridTemplateColumns = '1.4fr' + ' 1fr'.repeat(cols);
  }

  function sync() {
    var grid = document.querySelector('footer .foot-grid');
    if (!grid) return;
    /* v10: one set of columns everywhere. Built once per footer; a footer
       already carrying them (class rk-v10, and ten Features links) is left. */
    var f = grid.querySelector('.rk-v10.rk-features');
    if (!f || f.querySelectorAll('a').length !== FEATURE_PAGES.length) {
      grid.querySelectorAll('.foot-col.foot-links').forEach(function (old) { old.remove(); });
      grid.appendChild(column('Features', FEATURE_PAGES, 'rk-v10 rk-features'));
      grid.appendChild(column('How it works', WHAT_IT_DOES, 'rk-v10 rk-synced'));
      grid.appendChild(column('Rockkt', ROCKKT, 'rk-v10 rk-synced'));
    }
    layout(grid);
  }

  /* v10: "Terms and privacy" (The Boring Stuff) beside the copyright line,
     inside the same span so the bar's own layout is untouched. Idempotent. */
  function bottomLinks() {
    var spans = document.querySelectorAll('footer .foot-bottom span');
    for (var i = 0; i < spans.length; i++) {
      if (!/©|&copy;|\(c\)/i.test(spans[i].textContent || '')) continue;
      if (spans[i].querySelector('a.rk-terms')) return;
      var a = document.createElement('a');
      a.className = 'rk-terms';
      a.href = '/pages/the-boring-stuff';
      a.textContent = 'Terms and privacy';
      a.style.cssText = 'color:inherit;text-decoration:underline;text-underline-offset:3px;margin-left:12px';
      spans[i].appendChild(a);
      return;
    }
  }

  /* The copyright line. Two corrections, both idempotent, both applied here
     because index.liquid and the hand-built templates each hold their own copy
     inside files the Admin API will not replace as text. Both footer snippets
     were also fixed at source, so on most pages there is nothing to do.

       "Rockkt Ltd." -> "Rockkt."                        (from v4)
       "Registered in England & Wales." -> gone           (new in v6)

     ── BEFORE ANYONE PUTS THE SECOND ONE BACK, OR TAKES IT FURTHER ─────────
     That sentence was the ONLY place on the whole site that said where the
     company is registered - checked across the footer and /pages/the-boring-
     stuff on 23 Sept 2026, and the only hit anywhere was this line. A UK
     limited company's website is normally expected to state its registered
     name, its company number and its place of registration somewhere a visitor
     can find. Glen asked for it off the footer, which is a layout decision and
     fine; where those particulars now live is a separate question and it is
     open. If they go back anywhere, The Boring Stuff is the page for them.
     This is a note to check, not legal advice. */
  function name() {
    var spans = document.querySelectorAll('footer .foot-bottom span');
    for (var i = 0; i < spans.length; i++) {
      var t = spans[i].textContent;
      if (t.indexOf('Rockkt Ltd.') > -1) t = t.replace('Rockkt Ltd.', 'Rockkt.');
      t = t.replace(/\s*Registered in England\s*&\s*Wales\.?/i, '');
      if (t !== spans[i].textContent) spans[i].textContent = t;
    }
  }

  /* "Delivered with care, from the UK." — removed everywhere.

     WHY A SCRIPT AND NOT JUST A DELETE. The line is written out four ways: in
     snippets/rockkt-home-foot-v1.liquid and snippets/rockkt-page-foot.liquid,
     which were edited at source and no longer carry it; and inside
     templates/index.liquid and the other hand-built templates, which are past
     what the Admin API will replace as text. This is the only lever that
     reaches those. Same route, and the same reason, as name() above.

     It matches on the span's own text rather than an index, so it cannot take
     the copyright line with it if the order ever changes, and it leaves the
     currency picker that sits in the same bar alone. Idempotent: a footer that
     has already been edited at source has nothing here to find.

     When index.liquid is next rebuilt, delete the span there and this can go. */
  function tagline() {
    var spans = document.querySelectorAll('footer .foot-bottom span');
    for (var i = 0; i < spans.length; i++) {
      if (/Delivered with care/i.test(spans[i].textContent || '')) {
        spans[i].parentNode.removeChild(spans[i]);
      }
    }
  }

  /* "Studio or Managed", after Pricing, in every footer.

     FOUND BY THE PRICING LINK, NOT BY COLUMN NAME. The footers do not agree on
     their columns: snippets/rockkt-page-foot.liquid has "Rockkt", the
     homepage's own footer snippet has "Explore", and the hand-built templates
     each carry whatever they were built with. All of them have a Pricing link,
     and the new page belongs next to it - it is the page you read before
     pricing, or instead of it.

     Both footer snippets carry the link at source, so on most pages this finds
     it already there and does nothing. It is here for the footers inside
     index.liquid and the other templates the Admin API will not replace as
     text. Matched on the path, so an absolute or relative href both count.
     Idempotent: it never adds a second copy. */
  var SM_PATH = '/pages/studio-or-managed';
  function studioLink() {
    /* The site footer's link grid, same scope as sync(): a bare 'footer' can
       match a <footer> inside a homepage mock-up before it reaches this one. */
    var foot = document.querySelector('footer .foot-grid');
    if (!foot) return;
    var links = foot.querySelectorAll('a[href]');
    var pricing = null;
    for (var i = 0; i < links.length; i++) {
      var path = links[i].pathname || '';
      if (path === SM_PATH) return;
      if (!pricing && path === '/pages/pricing') pricing = links[i];
    }
    if (!pricing) return;
    var a = document.createElement('a');
    a.href = SM_PATH;
    a.textContent = 'Studio or Managed';
    pricing.parentNode.insertBefore(a, pricing.nextSibling);
  }

  /* The badge row under the logo. Rebuilt only when it still carries one of
     the old claims, so a footer fixed at source is left alone. The icons are
     the sprite's own symbols, the same two the snippets use. */
  var OLD_BADGE = /99%|FSC|GDPR|Carbon/i;
  function badges() {
    var rows = document.querySelectorAll('footer .foot-badges');
    for (var i = 0; i < rows.length; i++) {
      if (!OLD_BADGE.test(rows[i].textContent || '')) continue;
      rows[i].innerHTML =
        '<span><svg class="icn"><use href="#g-check-circle"/></svg>Royal Mail tracked</span>' +
        '<span><svg class="icn"><use href="#g-check"/></svg>No minimum term</span>';
    }
  }

  /* "Rockkt Managed", after "Studio or Managed", in every footer. Same
     approach as studioLink(), and it runs after it, so the anchor is always
     there. Idempotent: it never adds a second copy. */
  var RM_PATH = '/pages/sales-gifting';
  function managedLink() {
    var foot = document.querySelector('footer .foot-grid');
    if (!foot) return;
    var links = foot.querySelectorAll('a[href]');
    var sm = null;
    for (var i = 0; i < links.length; i++) {
      var path = links[i].pathname || '';
      if (path === RM_PATH) return;
      if (!sm && path === SM_PATH) sm = links[i];
    }
    if (!sm) return;
    var a = document.createElement('a');
    a.href = RM_PATH;
    a.textContent = 'Rockkt Managed';
    sm.parentNode.insertBefore(a, sm.nextSibling);
  }

  /* "Join Rockkt" goes to /pages/join everywhere (Glen, 9 Oct). Footers built
     before then still point at /pages/request-an-invite. Only links whose text
     says Join Rockkt are moved; a Studio "Request an invite" link is left. */
  function joinLink() {
    var links = document.querySelectorAll('footer .foot-grid a[href]');
    for (var i = 0; i < links.length; i++) {
      if ((links[i].pathname || '') === '/pages/request-an-invite' && /join rockkt/i.test(links[i].textContent || '')) {
        links[i].setAttribute('href', '/pages/join');
      }
    }
  }

  function run() { sync(); name(); tagline(); studioLink(); managedLink(); joinLink(); badges(); bottomLinks(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  var rt = null;
  window.addEventListener('resize', function () {
    if (rt) clearTimeout(rt);
    rt = setTimeout(function () { var g = document.querySelector('footer .foot-grid'); if (g) layout(g); }, 120);
  });
})();
